import React from "react";
import {
  Grid,
  CardContent,
  CardActions,
  Button,
  Typography,
  Divider,
  Box,
} from "@material-ui/core";
import { useQuery } from "react-query";
import { useFirebase } from "../Firebase";
import { useError } from "../ErrorProvider";
import { PageHeader, AppCard, CardSkeleton } from "../UI";

const Promotional = () => {
  const firebase = useFirebase();
  const { showError } = useError();
  const { data, isLoading } = useQuery(
    "CompanyStatistics",
    firebase.getCompanyStatistics,
    {
      select: (response) => response?.data,
      onError: (err) => showError(err),
    }
  );

  const handleDownload = (url, title) => (event) => {
    event.preventDefault();
    if (!url) {
      showError(`${title} is not available at this time.`);
      return;
    }

    window.open(url, "_blank", "noopener,noreferrer");
  };

  const renderCard = (title, description, url) => {
    const isAvailable = Boolean(url);

    return (
      <AppCard style={{ height: "100%" }}>
        <CardContent>
          <Box textAlign="center" padding="6px 6px 12px">
            <Typography variant="h5">{title}</Typography>
            <Box mt={1}>
              <Typography variant="body2" color="textSecondary">
                {description}
              </Typography>
            </Box>
          </Box>
        </CardContent>
        <Divider />
        <CardActions>
          <Box flexBasis="100%" textAlign="center">
            <Button
              variant={isAvailable ? "contained" : "text"}
              color="primary"
              disabled={!isAvailable}
              onClick={handleDownload(url, title)}
            >
              {isAvailable ? "Download" : "Unavailable"}
            </Button>
          </Box>
        </CardActions>
      </AppCard>
    );
  };

  return (
    <div>
      <PageHeader title="Promotional Material" />
      <Grid container spacing={3}>
        {isLoading ? (
          <>
            <Grid item xs={12} md={6}>
              <CardSkeleton rows={2} />
            </Grid>
            <Grid item xs={12} md={6}>
              <CardSkeleton rows={2} />
            </Grid>
          </>
        ) : (
          <>
            <Grid item xs={12} md={6}>
              {renderCard(
                "Employee Flyer",
                "Share this flyer with your employees to give them an overview of Smart Squirrel and instructions on how to get started.",
                data?.flyerURL
              )}
            </Grid>
            <Grid item xs={12} md={6}>
              {renderCard(
                "Employee Business Card Handout",
                "Download this business card handout to share quick access to Smart Squirrel. It's an easy way for employees to learn about the program and start using it right away.",
                data?.handoutURL
              )}
            </Grid>
          </>
        )}
      </Grid>
    </div>
  );
};

export default Promotional;
